<script setup>
import { ref } from 'vue'
import axios from 'axios'
import SmartCaptcha from 'vue3-smart-captcha'

const dialog = ref(false)
const isLoading = ref(false)

const name = ref('')
const text = ref('')
const nameTextRules = ref([
    value => {
        if (value) return true
        return 'Обязательное поле для заполнения'
    }
])

const email = ref('')
const emailRules = ref([
    value => {
        if (value) return true

        return 'Обязательное поле для заполнения'
    },
    value => {
        if (/.+@.+\..+/.test(value)) return true

        return 'Неверный вид Email'
    }
])

const SMARTCAPTCHA_KEY = process.env.VUE_APP_SMARTCAPTCHA_KEY
const captchaToken = ref('')

const handleSuccessCaptcha = (token) => {
    captchaToken.value = token
}

const sendFeedback = async () => {
    if (
        name.value.trim().length === 0 ||
        text.value.trim().length === 0 ||
        email.value.trim().length === 0 ||
        !/.+@.+\..+/.test(email.value) ||
        captchaToken.value.trim().length === 0
    ) {
        alert('Проверьте веденные данные и попробуйте еще раз')
        return
    }

    let startUrl = ''
    if (process.env.VUE_APP_SERVER_URL) {
        startUrl = process.env.VUE_APP_SERVER_URL
    }
    if (!startUrl) {
        startUrl = window.location.origin + '/api'
    }

    isLoading.value = true

    try {
        await axios.post(startUrl + '/feedback', {}, {
            params: {
                sender_name: name.value,
                sender_email: email.value,
                text: text.value,
                captcha_token: captchaToken.value
            }
        })
 
        alert('Сообщение было успешно отправлено')

        name.value = ''
        email.value = ''
        text.value = ''
    } catch (error) {
        if (error.status === 403) {
            alert('Вы не прошли проверку CAPTCHA')
        } else if (error.status === 503) {
            alert('Произошла ошибка на сервере, попробуйте позднее')
        }
    } finally {
        dialog.value = false
        captchaToken.value = ''
        isLoading.value = false
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        activator="#feedback-activator"
        max-width="800"
    >
        <template v-slot:default>
            <v-card>
                <div class="container">
                    <h1 class="title">
                        Обратная связь
                    </h1>
                    <form
                        class="inputs"
                        @submit.prevent="sendFeedback"
                    >
                        <v-text-field
                            v-model="name"
                            :rules="nameTextRules"
                            label="Как к вам обращаться?"
                            variant="outlined"
                        />
                        <v-text-field
                            v-model="email"
                            :rules="emailRules"
                            label="Укажите Ваш Email для обратной связи"
                            variant="outlined"
                        />
                        <v-textarea
                            v-model="text"
                            :rules="nameTextRules"
                            label="Текст сообщения"
                            variant="outlined"
                        />
                        <SmartCaptcha
                            :sitekey="SMARTCAPTCHA_KEY"
                            hl="ru"
                            @success="handleSuccessCaptcha"
                        />
                        <v-btn
                            class="submit-btn"
                            color="rgba(59, 102, 211, 1)"
                            :disabled="captchaToken.trim().length === 0 || isLoading"
                            type="submit"
                        >
                            {{ !isLoading ? 'Отправить' : 'Отправка...' }}
                        </v-btn>
                    </form>
                </div>
            </v-card>
        </template>
    </v-dialog>
</template>

<style lang="scss" scoped>
.container {
    padding: 40px 50px;
}

.title {
    font-size: 28px;
    font-weight: 500;
    line-height: 36px;
}

.inputs {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.submit-btn {
    width: 100%;
    height: 56px;
}
</style>